export const Title = ({ children }) => {
  return <div className='title-area'>{children}</div>;
};

const Main = () => {
  return (
    <h2 className='header-tit-02'>
      동의서 작성을 위해
      <br />
      보호자 정보를 입력해 주세요
    </h2>
  );
};

const Sub = () => {
  return <span className='sub-tit-01'>입원 절차를 위해 보호자 정보를 확인하고 있어요.</span>;
};

Title.Main = Main;
Title.Sub = Sub;
